// ไฟล์: frontend/src/pages/admin/TeacherWorks.js
import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import Sidebar from '../../components/Sidebar';
import Footer from '../../components/Footer';
import api from '../../services/api';
import Swal from 'sweetalert2';

function AdminTeacherWorks() {
  const [works, setWorks] = useState([]);
  const [teachers, setTeachers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    id: '',
    teacher_id: '',
    title: '',
    description: '',
    work_type: 'teaching_material',
    work_date: '',
    attachment: null
  });
  const [formMode, setFormMode] = useState('add'); // 'add' หรือ 'edit'
  const [selectedFileName, setSelectedFileName] = useState('');
  const [filterTeacherId, setFilterTeacherId] = useState('all');
  const [filterWorkType, setFilterWorkType] = useState('all');
  
  // ประเภทผลงาน
  const workTypes = [
    { value: 'teaching_material', label: 'สื่อการสอน' },
    { value: 'research', label: 'งานวิจัย' },
    { value: 'innovation', label: 'นวัตกรรม' },
    { value: 'seminar', label: 'อบรม/สัมมนา' },
    { value: 'other', label: 'อื่นๆ' }
  ];
  
  useEffect(() => {
    fetchTeacherWorks();
    fetchTeachers();
  }, []);
  
  const fetchTeacherWorks = async () => {
    try {
      setIsLoading(true);
      const response = await api.teacherWork.getAllTeacherWorks();
      setWorks(response.data.data || []);
    } catch (error) {
      console.error('Error fetching teacher works:', error);
      Swal.fire({
        icon: 'error',
        title: 'เกิดข้อผิดพลาด',
        text: 'ไม่สามารถโหลดข้อมูลผลงานครูได้',
        confirmButtonColor: '#ff6b01'
      });
    } finally {
      setIsLoading(false);
    }
  };
  
  const fetchTeachers = async () => {
    try {
      const response = await api.user.getAllTeachers();
      setTeachers(response.data.data || []);
    } catch (error) {
      console.error('Error fetching teachers:', error);
    }
  };
  
  const handleShowAddModal = () => {
    // ตั้งค่าวันที่เป็นวันปัจจุบัน
    const today = new Date().toISOString().split('T')[0];
    
    setFormData({
      id: '',
      teacher_id: teachers.length > 0 ? teachers[0].id : '',
      title: '',
      description: '',
      work_type: 'teaching_material',
      work_date: today,
      attachment: null
    });
    setSelectedFileName('');
    setFormMode('add');
    setShowModal(true);
  };
  
  const handleShowEditModal = (work) => {
    setFormData({
      id: work.id,
      teacher_id: work.teacher_id,
      title: work.title,
      description: work.description || '',
      work_type: work.work_type,
      work_date: work.work_date,
      attachment: null
    });
    setSelectedFileName(work.attachment || '');
    setFormMode('edit');
    setShowModal(true);
  };
  
  const handleCloseModal = () => {
    setShowModal(false);
  };
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };
  
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData({
        ...formData,
        attachment: file
      });
      setSelectedFileName(file.name);
    }
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // ตรวจสอบข้อมูลที่จำเป็น
    if (!formData.teacher_id || !formData.title || !formData.work_type || !formData.work_date) {
      Swal.fire({
        icon: 'warning',
        title: 'กรุณากรอกข้อมูลให้ครบถ้วน',
        text: 'กรุณากรอกครูผู้สอน, หัวข้อ, ประเภทผลงาน และวันที่',
        confirmButtonColor: '#ff6b01'
      });
      return;
    }
    
    try {
      setIsLoading(true);
      
      // สร้าง FormData สำหรับส่งข้อมูลพร้อมไฟล์แนบ
      const data = new FormData();
      data.append('teacher_id', formData.teacher_id);
      data.append('title', formData.title);
      data.append('description', formData.description);
      data.append('work_type', formData.work_type);
      data.append('work_date', formData.work_date);
      
      if (formData.attachment) {
        data.append('attachment', formData.attachment);
      }
      
      let response;
      if (formMode === 'add') {
        // เพิ่มผลงานใหม่
        response = await api.teacherWork.createTeacherWork(data);
        Swal.fire({
          icon: 'success',
          title: 'สำเร็จ',
          text: 'เพิ่มผลงานเรียบร้อยแล้ว',
          confirmButtonColor: '#ff6b01'
        });
      } else {
        // แก้ไขข้อมูลผลงาน
        response = await api.teacherWork.updateTeacherWork(formData.id, data);
        Swal.fire({
          icon: 'success',
          title: 'สำเร็จ',
          text: 'แก้ไขข้อมูลผลงานเรียบร้อยแล้ว',
          confirmButtonColor: '#ff6b01'
        });
      }
      
      // ปิด Modal และโหลดข้อมูลใหม่
      setShowModal(false);
      fetchTeacherWorks();
    } catch (error) {
      console.error('Error saving teacher work:', error);
      Swal.fire({
        icon: 'error',
        title: 'เกิดข้อผิดพลาด',
        text: 'ไม่สามารถบันทึกข้อมูลผลงานได้',
        confirmButtonColor: '#ff6b01'
      });
    } finally {
      setIsLoading(false);
    }
  };
  
  const handleDelete = (id, title) => {
    Swal.fire({
      title: 'ยืนยันการลบ',
      text: `คุณแน่ใจหรือไม่ว่าต้องการลบผลงาน "${title}"?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#ff6b01',
      cancelButtonColor: '#d33',
      confirmButtonText: 'ใช่, ลบข้อมูล',
      cancelButtonText: 'ยกเลิก'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await api.teacherWork.deleteTeacherWork(id);
          Swal.fire({
            icon: 'success',
            title: 'ลบข้อมูลสำเร็จ',
            text: 'ลบข้อมูลผลงานเรียบร้อยแล้ว',
            confirmButtonColor: '#ff6b01'
          });
          fetchTeacherWorks();
        } catch (error) {
          console.error('Error deleting teacher work:', error);
          Swal.fire({
            icon: 'error',
            title: 'เกิดข้อผิดพลาด',
            text: 'ไม่สามารถลบข้อมูลผลงานได้',
            confirmButtonColor: '#ff6b01'
          });
        }
      }
    });
  };
  
  // แปลงประเภทผลงานเป็นข้อความไทย
  const getWorkTypeName = (type) => {
    const found = workTypes.find(wt => wt.value === type);
    return found ? found.label : type;
  };
  
  // แปลงวันที่ให้อยู่ในรูปแบบไทย
  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('th-TH', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };
  
  // สร้าง URL สำหรับดาวน์โหลดไฟล์แนบ
  const getDownloadUrl = (id) => {
    return api.teacherWork.getDownloadUrl(id);
  };
  
  // กรองข้อมูลตามเงื่อนไข
  const filteredWorks = works.filter(work => {
    if (filterTeacherId !== 'all' && work.teacher_id !== parseInt(filterTeacherId)) {
      return false;
    }
    if (filterWorkType !== 'all' && work.work_type !== filterWorkType) {
      return false;
    }
    return true;
  });
  
  return (
    <div className="wrapper">
      <Header />
      <Sidebar />
      
      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="m-0">ผลงานครู</h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <a href="/admin/dashboard">หน้าหลัก</a>
                  </li>
                  <li className="breadcrumb-item active">ผลงานครู</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        
        <section className="content">
          <div className="container-fluid">
            {/* ตัวกรอง */}
            <div className="card card-orange card-outline">
              <div className="card-header">
                <h3 className="card-title">ตัวกรอง</h3>
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="collapse"
                  >
                    <i className="fas fa-minus"></i>
                  </button>
                </div>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>ครูผู้สอน</label>
                      <select
                        className="form-control"
                        value={filterTeacherId}
                        onChange={(e) => setFilterTeacherId(e.target.value)}
                      >
                        <option value="all">ทั้งหมด</option>
                        {teachers.map(teacher => (
                          <option key={teacher.id} value={teacher.id}>
                            {teacher.first_name} {teacher.last_name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>ประเภทผลงาน</label>
                      <select
                        className="form-control"
                        value={filterWorkType}
                        onChange={(e) => setFilterWorkType(e.target.value)}
                      >
                        <option value="all">ทั้งหมด</option>
                        {workTypes.map(type => (
                          <option key={type.value} value={type.value}>
                            {type.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-4 d-flex align-items-end">
                    <button
                      className="btn btn-orange"
                      onClick={handleShowAddModal}
                    >
                      <i className="fas fa-plus mr-2"></i>
                      เพิ่มผลงานครู
                    </button>
                  </div>
                </div>
              </div>
            </div>
            
            {/* รายการผลงาน */}
            <div className="card card-orange">
              <div className="card-header">
                <h3 className="card-title">รายการผลงานครู</h3>
              </div>
              <div className="card-body">
                {isLoading ? (
                  <div className="loading-spinner">
                    <i className="fas fa-spinner fa-spin"></i>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-bordered table-striped">
                      <thead>
                        <tr>
                          <th style={{ width: '50px' }}>ลำดับ</th>
                          <th>หัวข้อ</th>
                          <th style={{ width: '150px' }}>ครูผู้สอน</th>
                          <th style={{ width: '120px' }}>ประเภท</th>
                          <th style={{ width: '120px' }}>วันที่</th>
                          <th style={{ width: '80px' }}>ไฟล์แนบ</th>
                          <th style={{ width: '120px' }}>ตัวเลือก</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredWorks.length === 0 ? (
                          <tr>
                            <td colSpan="7" className="text-center">
                              ไม่พบข้อมูลผลงาน
                            </td>
                          </tr>
                        ) : (
                          filteredWorks.map((work, index) => (
                            <tr key={work.id}>
                              <td>{index + 1}</td>
                              <td>
                                <strong>{work.title}</strong>
                                {work.description && (
                                  <p className="text-muted mb-0 small">
                                    {work.description.length > 100 
                                      ? work.description.substring(0, 100) + '...' 
                                      : work.description}
                                  </p>
                                )}
                              </td>
                              <td>{work.teacher_name}</td>
                              <td>{getWorkTypeName(work.work_type)}</td>
                              <td>{formatDate(work.work_date)}</td>
                              <td className="text-center">
                                {work.attachment ? (
                                  <a 
                                    href={getDownloadUrl(work.id)} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="btn btn-sm btn-outline-primary"
                                  >
                                    <i className="fas fa-download"></i>
                                  </a>
                                ) : (
                                  <span className="text-muted">-</span>
                                )}
                              </td>
                              <td>
                                <button
                                  className="btn btn-info btn-sm mr-1"
                                  onClick={() => handleShowEditModal(work)}
                                >
                                  <i className="fas fa-edit"></i>
                                </button>
                                <button
                                  className="btn btn-danger btn-sm"
                                  onClick={() => handleDelete(work.id, work.title)}
                                >
                                  <i className="fas fa-trash"></i>
                                </button>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
            
            {/* สรุปผลงานตามครู */}
            <div className="row">
              {teachers.map(teacher => {
                const teacherWorks = works.filter(w => w.teacher_id === teacher.id);
                return (
                  <div className="col-md-4" key={teacher.id}>
                    <div className="card card-outline card-orange">
                      <div className="card-header">
                        <h3 className="card-title">{teacher.first_name} {teacher.last_name}</h3>
                      </div>
                      <div className="card-body">
                        <div className="d-flex justify-content-between mb-2">
                          <span>จำนวนผลงานทั้งหมด:</span>
                          <span className="badge badge-primary">{teacherWorks.length} ชิ้น</span>
                        </div>
                        {workTypes.map(type => {
                          const count = teacherWorks.filter(w => w.work_type === type.value).length;
                          return count > 0 ? (
                            <div className="d-flex justify-content-between mb-1" key={type.value}>
                              <span>{type.label}:</span>
                              <span className="badge badge-info">{count} ชิ้น</span>
                            </div>
                          ) : null;
                        })}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>
      </div>
      
      {/* Modal เพิ่ม/แก้ไขข้อมูลผลงาน */}
      {showModal && (
        <div className="modal fade show" style={{ display: 'block', paddingRight: '15px' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header bg-orange">
                <h5 className="modal-title">
                  {formMode === 'add' ? 'เพิ่มผลงานใหม่' : 'แก้ไขข้อมูลผลงาน'}
                </h5>
                <button type="button" className="close" onClick={handleCloseModal}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="modal-body">
                  <div className="form-group">
                    <label>ครูผู้สอน <span className="text-danger">*</span></label>
                    <select
                      className="form-control"
                      name="teacher_id"
                      value={formData.teacher_id}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">-- เลือกครูผู้สอน --</option>
                      {teachers.map(teacher => (
                        <option key={teacher.id} value={teacher.id}>
                          {teacher.first_name} {teacher.last_name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group">
                    <label>หัวข้อผลงาน <span className="text-danger">*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      name="title"
                      value={formData.title}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>ประเภทผลงาน <span className="text-danger">*</span></label>
                        <select
                          className="form-control"
                          name="work_type"
                          value={formData.work_type}
                          onChange={handleInputChange}
                          required
                        >
                          {workTypes.map(type => (
                            <option key={type.value} value={type.value}>
                              {type.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>วันที่ผลงาน <span className="text-danger">*</span></label>
                        <input
                          type="date"
                          className="form-control"
                          name="work_date"
                          value={formData.work_date}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <label>รายละเอียด</label>
                    <textarea
                      className="form-control"
                      name="description"
                      value={formData.description}
                      onChange={handleInputChange}
                      rows="4"
                    ></textarea>
                  </div>
                  <div className="form-group">
                    <label>ไฟล์แนบ</label>
                    <div className="input-group">
                      <div className="custom-file">
                        <input
                          type="file"
                          className="custom-file-input"
                          id="attachment"
                          name="attachment"
                          onChange={handleFileChange}
                        />
                        <label className="custom-file-label" htmlFor="attachment">
                          {selectedFileName || 'เลือกไฟล์'}
                        </label>
                      </div>
                    </div>
                    {formMode === 'edit' && selectedFileName && !formData.attachment && (
                      <small className="text-muted">
                        ไฟล์แนบปัจจุบัน: {selectedFileName}
                      </small>
                    )}
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>
                    ยกเลิก
                  </button>
                  <button type="submit" className="btn btn-orange" disabled={isLoading}>
                    {isLoading ? (
                      <><i className="fas fa-spinner fa-spin"></i> กำลังบันทึก...</>
                    ) : (
                      <>บันทึก</>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
          
          {/* พื้นหลังทึบ */}
          <div className="modal- fade show"></div>
        </div>
      )}
      
      <Footer />
    </div>
  );
}

export default AdminTeacherWorks;